import style from './input-code.module.scss'
import React, { useEffect, useRef, useState } from 'react'

export type InputCodeProps = {
  onValueChanged?: (value: string) => void
  isInvalid?: boolean
  inputCodeLength?: number
}

export const InputCode: React.FC<InputCodeProps> = (props) => {
  const { onValueChanged, isInvalid = false, inputCodeLength = 6 } = props

  const [value, setValue] = useState('')
  const [inputOnFocus, setInputOnFocus] = useState(false)
  const inputRef = useRef<HTMLInputElement>(null)

  const handleValueCleanup = (val: string): string => {
    const onlyNumber = val.split(/[^0-9]/g).join('')
    const onlyFirstSixChars = onlyNumber.slice(0, 6)
    setValue(onlyFirstSixChars)
    return onlyFirstSixChars
  }

  const handleTextChange = (e: any): void => {
    e.target.value = handleValueCleanup(e.target.value)
    refocusCursor(e)
  }

  useEffect(() => {
    if (onValueChanged) onValueChanged(value)
  }, [value])

  const handleKeyDown = (e: any): void => {
    if (!inputRef?.current) return
    const KEY_RIGHT = 39
    const KEY_SPACE = 32
    const KEY_END = 35
    const KEY_0 = 48
    const KEY_1 = 49
    const KEY_2 = 50
    const KEY_3 = 51
    const KEY_4 = 52
    const KEY_5 = 53
    const KEY_6 = 54
    const KEY_7 = 55
    const KEY_8 = 56
    const KEY_9 = 57
    const KEYS = [KEY_0, KEY_1, KEY_2, KEY_3, KEY_4, KEY_5, KEY_6, KEY_7, KEY_8, KEY_9]

    if (e.target.selectionStart >= 5 && e.keyCode === KEY_RIGHT) {
      e.preventDefault()
    } else if (value.length >= 6 && e.keyCode === KEY_END) {
      e.preventDefault()
    } else if (e.keyCode === KEY_SPACE) {
      e.preventDefault()
    } else if (value.length >= 5) {
      const char = KEYS.includes(e.keyCode) ? (e.keyCode - 48).toString() : ''
      if (!char) return
      e.preventDefault()
      const currLoc = e.target.selectionStart
      e.target.value = handleValueCleanup(`${e.target.value.slice(0, currLoc)}${char}${e.target.value.slice(currLoc + 1, 6)}`)
      const nextCurrLoc = currLoc >= 5 ? 5 : currLoc + 1
      inputRef?.current.setSelectionRange(nextCurrLoc, nextCurrLoc)
    }
  }

  const handleClick = (e: any): void => {
    refocusCursor(e)
  }

  const refocusCursor = (e: any): void => {
    if (!inputRef?.current) return
    const currLoc = e.target.selectionStart

    const nextCurrLoc = currLoc >= 5 ? 5 : currLoc

    inputRef?.current.blur()
    inputRef?.current.setSelectionRange(nextCurrLoc, nextCurrLoc)
    inputRef?.current.focus()
  }

  return (
    <div className={`${style.sixDigitCode} ${isInvalid ? style.invalid : ''}`}>
      <div className={style.inputBackground}>
        {[...Array(inputCodeLength)].map((_, i) => (
          <div id={`field-${i}`} key={i}>
            <div className={`${value.length === i && inputOnFocus ? style.inFocus : ''}`}>{value[i]}</div>
          </div>
        ))}
      </div>
      <input
        type="text"
        ref={inputRef}
        onChange={handleTextChange}
        onKeyDown={handleKeyDown}
        onClick={handleClick}
        onFocus={() => setInputOnFocus(true)}
        onBlur={() => setInputOnFocus(false)}
      />
    </div>
  )
}
